module.exports = __webpack_public_path__ + "static/media/circledivided.087c4975.svg";